import React from 'react';
import { toastr } from 'react-redux-toastr';

import MessageBody from './template/MessageBody';
import translator from '../localization/translator';


let collectBody = (message, serverError) => {
	const toasterOptions = {
		showCloseButton: !!serverError,
		component: (
			<MessageBody message={message} />
		)
	};
	if (serverError) {
		toasterOptions.timeOut = 0;
		toasterOptions.removeOnHover = false;
	}
	return toasterOptions;
};

export default class Notifier {
	static warning(message, title='') {
		toastr.warning(translator.translate(title), '', collectBody(message));
	}
	static success(message, title='') {
		toastr.success(translator.translate(title), '', collectBody(message));
	}
	static error(message, title='', serverError) {
		toastr.error(translator.translate(title), '', collectBody(message, serverError));
	}
	static info(message, title='') {
		toastr.info(translator.translate(title), '', collectBody(message));
	}
}
